import { useCallback } from 'react';
import useAppModal from 'hooks/useAppModal';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import MessageLogViewModal from './MessageLogViewModal';
import { MESSAGE_LOG_VIEW_MODAL_ID } from './MessageLogViewModal.constants';

const useMessageLogViewModal = () => {
  const { openModal } = useAppModal();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const navigateBack = useCallback(() => {
    navigate('..', { replace: true, relative: 'path' });
  }, [navigate]);

  const openViewMessageLogModal = ({
    messageLogUid,
  }: {
    messageLogUid: string;
  }) => {
    openModal({
      customContent: (
        <MessageLogViewModal
          messageLogUid={messageLogUid}
          closeModal={navigateBack}
        />
      ),
      id: MESSAGE_LOG_VIEW_MODAL_ID,
      title: t('pageAutomations.messageLog.modal.title'),
      closeOnHide: false,
      onHide: navigateBack,
    });
  };

  return { openViewMessageLogModal };
};

export default useMessageLogViewModal;
